import { render, staticRenderFns } from "./AdminEntityList.vue?vue&type=template&id=0f8d1a18&scoped=true"
import script from "./AdminEntityList.vue?vue&type=script&lang=js"
export * from "./AdminEntityList.vue?vue&type=script&lang=js"
import style0 from "./AdminEntityList.vue?vue&type=style&index=0&id=0f8d1a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d1a18",
  null
  
)

export default component.exports